<template>
	<div>
	<el-dialog top="5vh" title="修改学生信息" width="40%" :visible.sync="updStudentMode">
		<el-form label-width="100px">
			<el-form-item label="姓名">
				<el-input maxlength="20" v-model="userDetail.studentName" placeholder="请输入姓名"></el-input>
			</el-form-item>
			<el-form-item label="昵称">
				<el-input maxlength="20" v-model="userDetail.studentNickName" placeholder="请输入昵称"></el-input>
			</el-form-item>
		</el-form>
		<div style="text-align: center;">
			<el-button :disabled="!ifSubmit" @click="checkUpdStudent" size="small"
				type="primary" icon="el-icon-edit" round> 确认修改 </el-button>
		</div>
	</el-dialog>	
		
		
		
	<el-dialog top="5vh" title="新增用户" width="40%" :visible.sync="addUserMode">
		<el-form label-width="100px">
			<el-form-item label="用户类型">
				  <el-radio v-model="userDetail.userType" :label="1">学生</el-radio>
				  <el-radio v-model="userDetail.userType" :label="3">导师</el-radio>
				  <el-radio v-model="userDetail.userType" :label="2">班主任</el-radio>
			</el-form-item>
			<el-form-item label="姓名">
				<el-input maxlength="20" v-model="userDetail.name" placeholder="请输入姓名"></el-input>
			</el-form-item>
			<el-form-item label="昵称">
				<el-input maxlength="20" v-model="userDetail.nickName" placeholder="请输入昵称"></el-input>
			</el-form-item>
			<el-form-item label="电话/手机">
				 <el-popover
				    placement="right"
				    title="号码格式"
				    width="300"
				    trigger="hover">
					<div>格式为：00国家号-手机号；<b>注意：中国大陆手机号不写国家号，手机号第一位不能为0</b></div>
					<div style="margin-top:3px;">例如：美国手机号 1 (800) 643-7676 填成 001-8006437676；中国大陆手机号填成 15800000001</div>
					<el-input slot="reference" maxlength="20" placeholder="请输入号码" v-model="userDetail.phone"></el-input>
				  </el-popover>
			</el-form-item>
			<!-- <el-form-item label="用户登录密码">
				<el-popover
				   placement="right"
				   title="登录密码说明(6-20位)"
				   width="300"
				   trigger="hover">
					<div>如果用户此手机号未注册classin，则会进行注册，注册后根据此密码进行登录</div>
					<div style="margin-top:3px;">如果用户手机号已注册classin，此项请输入任意6-20位数字</div>
					<el-input slot="reference" maxlength="20" v-model="userDetail.password" placeholder="请输入用户登录密码"></el-input>
				 </el-popover>
			</el-form-item> -->
			<el-form-item v-if="userDetail.userType == 2" label="邮箱">
				<el-input maxlength="50" v-model="userDetail.email" placeholder="请输入邮箱"></el-input>
			</el-form-item>
			<el-form-item v-if="userDetail.userType == 3" label="时薪类型">
				<el-radio v-model="userDetail.types" label="USD">美元</el-radio>
				<el-radio v-model="userDetail.types" label="CNY">人民币</el-radio>
			</el-form-item>
			<el-form-item v-if="userDetail.userType == 3" label="时薪">
				<el-input oninput="if(value.length > 10) value=value.slice(0, 10)" type="number"
					v-model="userDetail.price"></el-input>
			</el-form-item>
			<el-form-item v-if="userDetail.userType == 3" label="支付方式">
					 <el-select v-model="userDetail.pay" placeholder="请选择">
					    <el-option
					      v-for="item in payTypes"
					      :key="item"
					      :label="item"
					      :value="item">
					    </el-option>
					  </el-select>
			</el-form-item>
			<el-form-item v-if="userDetail.userType == 3" label="支付账号">
				<el-input maxlength="45" v-model="userDetail.information" placeholder="请输入支付账号"></el-input>	
			</el-form-item>
			<el-form-item v-if="userDetail.userType == 3" label="账号姓名">
				<el-input maxlength="20" v-model="userDetail.informationName" placeholder="请输入账号姓名"></el-input>	
			</el-form-item>
			<el-form-item  v-if="userDetail.userType == 3" label="证件信息" >
			  <el-input maxlength="20" v-model="userDetail.identity"></el-input>
			</el-form-item>
			<el-form-item  v-if="userDetail.userType == 3" label="签约电话" >
			  <el-input maxlength="20" v-model="userDetail.teacherPhone"></el-input>
			</el-form-item>
		</el-form>
		<div style="text-align: center;">
			<el-button v-if="userDetail.id == null" :disabled="!ifSubmit" @click="checkAddUser" size="small"
				type="primary" icon="el-icon-edit" round> 确认新增 </el-button>
		</div>
	</el-dialog>
	<el-tabs v-model="pageIndex" @tab-click="handleClick" type="border-card">
		<el-input size="small" style="display:inline-block;width:200px;" v-model="searchInput"
			placeholder="根据姓名搜索" @keyup.enter.native="searchUser"></el-input>
		<el-button @click="searchUser" style="margin-left:5px;" size="small" icon="el-icon-search" circle></el-button>
		<el-tab-pane label="学生管理" name="student">
			<div>
				<el-table :data="studentList" style="width: 100%;margin-top:10px;" :row-style="{height:'60px'}"
					:height="windowHeight">
					<el-table-column prop="uid" label="ClassinId" ></el-table-column>
					<el-table-column prop="studentName" label="学生姓名"></el-table-column>
					<el-table-column prop="studentNickName" label="学生昵称" ></el-table-column>
					<el-table-column prop="studentPhone" label="学生手机"></el-table-column>
					<el-table-column width="100" fixed="right" label="操作">
						<template slot-scope="scope">
							<el-button :disabled="!ifSubmit" @click="showUpdStudentMode(scope.row)" type="text" size="small">修改信息</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination style="margin-top:10px;" @size-change="studentChangeSize"
					@current-change="studentChangePage" :current-page="studentPage"
					:page-sizes="[studentPageSize,10,20,40,studentSize]" :page-size="studentPageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="studentSize">
				</el-pagination>

			</div>
		</el-tab-pane>
		<el-tab-pane label="导师管理" name="teacher">
			<div>
				<el-table :data="teacherList" style="margin-top:10px;" :row-style="{height:'60px'}"
					:height="windowHeight">
					<el-table-column width="150" prop="uid" label="ClassinId" ></el-table-column>
					<el-table-column width="200" prop="teacherName" label="导师姓名"></el-table-column>
					<el-table-column width="200" prop="teacherNickName" label="导师昵称" ></el-table-column>
					<el-table-column width="200" prop="teacherPhone" label="导师手机"></el-table-column>
					<el-table-column width="100" prop="types" label="支付类型"></el-table-column>
					<el-table-column width="100" prop="teacherRate" label="导师时薪"></el-table-column>
					<el-table-column width="150" prop="teacherPay" label="支付方式"></el-table-column>
					<el-table-column width="200" prop="userName" label="账号名称"></el-table-column>
					<el-table-column width="200" prop="userInformation" label="支付账号"></el-table-column>
					<el-table-column width="200" prop="verificationCode" label="微信验证码"></el-table-column>
					<el-table-column width="200" prop="nickName" label="微信授权名"></el-table-column>
					<el-table-column width="200" prop="state" label="导师状态">
						<template slot-scope="scope">
							<span v-if="scope.row.state == 1">启用</span>
							<span v-if="scope.row.state == 2">停用</span>
						</template>
					</el-table-column>
					<el-table-column width="100" fixed="right" label="操作">
						<template slot-scope="scope">
							<el-button :disabled="!ifSubmit" style="color:#F56C6C;" v-if="scope.row.state == 1" @click="updTeacherState(3,scope.row.id,scope.row.uid,2)" type="text" size="small">停用</el-button>
							<el-button :disabled="!ifSubmit" v-if="scope.row.state == 2" @click="updTeacherState(3,scope.row.id,scope.row.uid,1)" type="text" size="small">启用</el-button>
						</template>
					</el-table-column>
				</el-table>
			
				<el-pagination style="margin-top:10px;" @size-change="teacherChangeSize"
					@current-change="teacherChangePage" :current-page="teacherPage"
					:page-sizes="[teacherPageSize,10,20,40,teacherSize]" :page-size="teacherPageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="teacherSize">
				</el-pagination>
			
			</div>
		</el-tab-pane>
		<el-tab-pane label="班主任管理" name="headmaster">
			<div>
				<el-table :data="headmasterList" style="width: 100%;margin-top:10px;" :row-style="{height:'60px'}"
					:height="windowHeight">
					<el-table-column width="150" prop="uid" label="ClassinId" ></el-table-column>
					<el-table-column width="200" prop="headmasterName" label="班主任姓名"></el-table-column>
					<el-table-column width="200" prop="headmasterNickname" label="班主任昵称" ></el-table-column>
					<el-table-column width="200" prop="headmasterPhone" label="班主任手机"></el-table-column>
					<el-table-column width="200" prop="headmasterMail" label="班主任邮箱"></el-table-column>
					<el-table-column width="200" prop="state" label="班主任状态">
						<template slot-scope="scope">
							<span v-if="scope.row.state == 1">启用</span>
							<span v-if="scope.row.state == 2">停用</span>
						</template>
					</el-table-column>
					<el-table-column width="100" fixed="right" label="操作">
						<template slot-scope="scope">
							<el-button :disabled="!ifSubmit" style="color:#F56C6C;" v-if="scope.row.state == 1" @click="updTeacherState(2,scope.row.id,scope.row.uid,2)" type="text" size="small">停用</el-button>
							<el-button :disabled="!ifSubmit" v-if="scope.row.state == 2" @click="updTeacherState(2,scope.row.id,scope.row.uid,1)" type="text" size="small">启用</el-button>
						</template>
					</el-table-column>
				</el-table>
			
				<el-pagination style="margin-top:10px;" @size-change="headmasterChangeSize"
					@current-change="headmasterChangePage" :current-page="headmasterPage"
					:page-sizes="[headmasterPageSize,10,20,40,headmasterSize]" :page-size="headmasterPageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="headmasterSize">
				</el-pagination>
			
			</div>
		</el-tab-pane>
	</el-tabs>
	<el-button @click="showAddMode" style="position:absolute;right:10px;top:68.5px;" size="small" round type="primary">新增用户</el-button>
	</div>
</template>

<script>
	import utils from "@/utils";
	export default {
		data() {
			return {
				ifSubmit:true,
				windowHeight: window.innerHeight - 227,
				pageIndex: 'student',

				studentList: [],
				studentPage: 1,
				studentSize:0,
				studentPageSize:0,

				teacherList: [],
				teacherPage: 1,
				teacherSize:0,
				teacherPageSize:0,

				headmasterList: [],
				headmasterPage: 1,
				headmasterSize:0,
				headmasterPageSize:0,

				pageSize: 1, //每页显示几条数据

				searchInput: "",
				
				addUserMode:false,
				userDetail:{userType:1,types:"USD"},//1 学生 2 班主任 3 导师
				
				payTypes:["支付宝","微信","银行卡","Paypal","Zellepay","1099"],
				
				updStudentMode:false,
			};
		},
		methods: {
			checkUpdStudent(){
				if(this.userDetail.studentName == null || this.userDetail.studentName.length == 0){
					this.$message({
						message: '请输入姓名后再确认',
						type: 'info',
					})
					return;
				}
				this.ifSubmit = false;
				utils.requestPost("修改学生信息", "students/updateStudent",this.userDetail).then((data) => {
					if(data.error_info.errno == 1){
						this.$message({
							message: '修改信息成功',
							type: "success",
							duration: 2000
						});
						this.updStudentMode = false;
						this.getStudents();
					}else{
						this.$message({
							message: "修改失败："+data.error_info.error,
							type: "warning",
							duration: 5000
						});
					}
					this.ifSubmit = true;
				})
				
			},
			showUpdStudentMode(detail){
				this.userDetail = JSON.parse(JSON.stringify(detail));
				this.updStudentMode = true;
			},
			updTeacherState(userType,id,uid,state){
				this.$confirm('确认修改导师/班主任状态吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					this.ifSubmit = false;
					utils.requestPost("修改导师状态", "userInfo/updTeacherState",{
						userType:userType,
						id:id,
						uid:uid,
						state:state
					}).then((data) => {
						if(data.error_info.errno == 1){
							this.$message({
								message: '修改状态成功',
								type: "success",
								duration: 2000
							});
							if(userType == 2){
								//重新查询班主任
								this.getHeadmasters();
							}else if(userType == 3){
								//重新查询导师
								this.getTeachers();
							}
						}else{
							this.$message({
								message: "修改失败："+data.error_info.error,
								type: "warning",
								duration: 5000
							});
						}
						this.ifSubmit = true;
					})
				})
			},
			checkAddUser(){
				if(this.userDetail.name == null || this.userDetail.name.length == 0){
					this.$message({
						message: '请输入姓名后再确认',
						type: 'info',
					})
					return;
				}
				if(this.userDetail.phone == null || this.userDetail.phone.length == 0){
					this.$message({
						message: '请输入手机后再确认',
						type: 'info',
					})
					return;
				}
				if(this.userDetail.userType == 2 && (this.userDetail.email == null || this.userDetail.email.length == 0)){
					this.$message({
						message: '请输入邮箱后再确认',
						type: 'info',
					})
					return;
				}
				
				if(this.userDetail.userType == 3 && (this.userDetail.price == null || this.userDetail.price.length == 0)){
					this.$message({
						message: '请输入时薪后再确认',
						type: 'info',
					})
					return;
				}
				
				if(this.userDetail.userType == 3 && (this.userDetail.pay == null || this.userDetail.pay.length == 0)){
					this.$message({
						message: '请选择支付方式后再确认',
						type: 'info',
					})
					return;
				}
				
				if(this.userDetail.userType == 3 && (this.userDetail.information == null || this.userDetail.information.length == 0)){
					this.$message({
						message: '请输入支付账号后再确认',
						type: 'info',
					})
					return;
				}
				if(this.userDetail.userType == 3 && (this.userDetail.informationName == null || this.userDetail.pay.informationName == 0)){
					this.$message({
						message: '请输入账号姓名后再确认',
						type: 'info',
					})
					return;
				}
				this.ifSubmit = false;
				utils.requestPost("注册用户", "userInfo/signUser",this.userDetail).then((data) => {
					if(data.error_info.errno == 1  || data.error_info.errno == 135 ||  data.error_info.errno == 133){
						this.$message({
							message: '用户注册成功',
							type: "success",
							duration: 2000
						});
						this.addUserMode = false;
						if(this.userDetail.userType == 1){
							this.studentPage = 1;
							//重新查询学生
							this.getStudents();
						}else if(this.userDetail.userType == 2){
							this.teacherPage = 1;
							//重新查询导师
							this.getTeachers();
						}else{
							this.headmasterPage = 1;
							//重新查询班主任
							this.getHeadmasters();
						}
					}else{
						this.$message({
							message: "注册失败："+data.error_info.error,
							type: "warning",
							duration: 5000
						});
					}
					this.ifSubmit = true;
				})
			},
			showAddMode(){
				this.addUserMode = true;
				this.userDetail = {userType:1,types:"USD"};
			},
			searchUser(){
				if (this.pageIndex === "student") {
					this.studentPage = 1;
					//重新查询学生
					this.getStudents();
				} else if (this.pageIndex === "teacher") {
					this.teacherPage = 1;
					//重新查询导师
					this.getTeachers();
				} else {
					this.headmasterPage = 1;
					//重新查询班主任
					this.getHeadmasters();
				}
			},
			computePageSize() {
				this.windowHeight = window.innerHeight - 227;
				let height = this.windowHeight - 60;
				this.pageSize = parseInt(height / 60);
				this.studentPageSize = parseInt(height / 60);
				this.teacherPageSize = parseInt(height / 60);
				this.headmasterPageSize = parseInt(height / 60);
			},
			//改变index
			handleClick(tab, event) {
				this.searchInput = "";
			},
			//学生切换页面
			studentChangePage(val) {
				this.studentPage = val;
				//重新查询学生
				this.getStudents();
			},
			//学生改变每页显示数
			studentChangeSize(e){
				this.studentPage = 1;
				this.studentPageSize = e;
				//重新查询学生
				this.getStudents();
			},
			//导师切换页面
			teacherChangePage(val) {
				this.teacherPage = val;
				//重新查询导师
				this.getTeachers();
			},
			//导师改变每页显示数
			teacherChangeSize(e){
				this.teacherPage = 1;
				this.teacherPageSize = e;
				//重新查询导师
				this.getTeachers();
			},
			//班主任切换页面
			headmasterChangePage(val) {
				this.headmasterPage = val;
				//重新查询班主任
				this.getHeadmasters();
			},
			//班主任改变每页显示数
			headmasterChangeSize(e){
				this.headmasterPage = 1;
				this.headmasterPageSize = e;
				//重新查询班主任
				this.getHeadmasters();
			},
			getStudents(){
				utils.requestPost("用户管理查询学生", "students/getStudents",{
					searchInput:this.searchInput,
					pageSize:this.studentPageSize,
					studentPage:this.studentPage,
				}).then((data) => {
					this.studentList = data.students;
					this.studentSize = data.total;
				})
			},
			getTeachers(){
				utils.requestPost("用户管理查询导师", "teacher/getTeachers",{
					searchInput:this.searchInput,
					pageSize:this.teacherPageSize,
					teacherPage:this.teacherPage,
				}).then((data) => {
					this.teacherList = data.teachers;
					this.teacherSize = data.total;
				})
			},
			getHeadmasters(){
				utils.requestPost("用户管理查询班主任", "headmaster/getHeadmasters",{
					searchInput:this.searchInput,
					pageSize:this.headmasterPageSize,
					headmasterPage:this.headmasterPage,
				}).then((data) => {
					this.headmasterList = data.headmasters;
					this.headmasterSize = data.total;
				})
			},
		},
		mounted() {
			this.computePageSize();
			//监听浏览器变化
			this.$nextTick(() => {
				window.addEventListener('resize', () => { //监听浏览器窗口大小改变
					this.computePageSize();
					this.searchUser();
				});
			})
			utils.requestPost("用户管理查询默认学生，导师，班主任", "userInfo/searchUsers",{
				searchInput:this.searchInput,
				pageSize:this.pageSize,
				studentPage:this.studentPage,
				teacherPage:this.teacherPage,
				headmasterPage:this.headmasterPage,
			}).then((data) => {
				this.studentList = data.student.students;
				this.studentSize = data.student.total;
				
				this.teacherList = data.teacher.teachers;
				this.teacherSize = data.teacher.total;
				
				this.headmasterList = data.headmaster.headmasters;
				this.headmasterSize = data.headmaster.total;
			})
		}
	};
</script>

<style>
</style>
